import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import useInvoke from "../../Tools/Invoker";
import DynamicGrid from "../../Tools/DynamicGrid";
import CheckToken from "../../_Login/CheckToken";

const Oilers = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    let response96 = useInvoke("WebApps", "96", {});

    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    useEffect(() => {

        if (response96.data.payload != undefined) {

            let myData = JSON.parse(response96.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => {

                let oilerName = `${entry[4]}-${entry[1]}`;

                let row = [
                    { type: "text", content: { text: `${entry[0]}` } },
                    { type: "link", content: { text: `${oilerName}`, link: `/Oilers/Details/${entry[0]}` } },
                    { type: "text", content: { text: `${entry[2]}` } },
                    { type: "text", content: { text: `${entry[8]}` } },
                    
                    { type: "text", content: { text: `${entry[1]}` } },
                    { type: "text", content: { text: `${entry[4]}` } },
                    { type: "text", content: { text: `${entry[5]}` } },
                    { type: "text", content: { text: `${entry[6]}` } }
                ];

                rowsList.push(row);
            });

            setColumns(["Oiler ID", "Oiler Name", "# Test Points", "# Configs", "JobNum", "Customer ID", "Created By", "Date Created"]);
            setRows(rowsList);
        }

    }, [response96.data.payload]);

    document.title = "Electrostatic Oilers";
    return (

        <>
            <div className="oilers">
                {user["email"] != undefined &&
                    <>
                        <div className="container" style={{ margin: "auto" }}>
                            <h2>Electrostatic Oilers</h2>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                                    <p><Link className="btn btn-primary" to="/Oilers/New">New Oiler</Link></p>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                                    <p style={{ marginLeft: "8px" }}><Link className="btn btn-secondary" to="/Oilers/Configuration/Blank">Blank Oiler Form</Link></p>
                                    <p style={{ marginLeft: "8px" }}><Link className="btn btn-secondary" to="/Oils">Manage Oils</Link></p>
                                    <p style={{ marginLeft: "8px" }}><Link className="btn btn-secondary" to="/Oilers/TestDiagrams">Test Diagrams</Link></p>                                    
                                </div>
                            </div>

                            {columns && rows && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} defaultsortindex={7} descending={true} />}

                        </div>
                        
                    </>
                }

            </div>

        </>
    );
}

export default Oilers;